import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';

export class ImageHeaderFooterCropStrategy implements ILoadingStrategy {
  private readonly MINIMUM_CREATIVE_RATIO = 4;

  alterConfiguration(formatContext: FormatContext): FormatContext {
    formatContext.config = {
      ...formatContext.config,
      creative: {
        ...formatContext.config.creative,
        objectFit: 'cover'
      }
    };
    return formatContext;
  }

  isRunnable(formatContext: FormatContext): boolean {
    const { creativeSource, adUnitType } = formatContext.context;
    const creativeRatio = formatContext.config.creative?.creativeRatio;
    return (
      creativeSource === 'image' &&
      (adUnitType === 'footer_ad' || adUnitType === 'header_ad') &&
      creativeRatio >= this.MINIMUM_CREATIVE_RATIO
    );
  }

  onAfterRender(formatContext: FormatContext): void {}

  onBeforeRender(formatContext: FormatContext): void {}

  onResize(formatContext: FormatContext): void {
    const creativeRatio = formatContext.config.creative?.creativeRatio;
    const creativeObjectFit = formatContext.config.creative?.objectFit;
    const creativeContainer = document.getElementById('creative');
    const creativeImage = creativeContainer
      ?.getElementsByTagName('img')
      .item(0);
    if (creativeContainer && creativeImage) {
      const creativeContainerRatio =
        creativeContainer.clientWidth / creativeContainer.clientHeight;
      if (creativeContainerRatio > creativeRatio) {
        creativeImage.style.objectFit = 'contain';
      } else {
        creativeImage.style.objectFit = creativeObjectFit;
      }
    }
  }
}
